/**
 * --------------------------------------------------------------------------
 * NJ : Textarea.js
 * --------------------------------------------------------------------------
 */

import { Data, Manipulator, Testing } from 'nj-utils';
import AbstractFormControl from './AbstractFormControl';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

// Required const for all components :
const NAME = 'textarea';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;

const SELECTOR = 'textarea';

class Textarea extends AbstractFormControl {
  constructor(element, config) {
    super(Textarea, element, Manipulator.extend(true, {}, config));

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static matches(element) {
    return element.tagName === 'TEXTAREA';
  }

  static rejectMatch(component, element) {
    Testing.assert(
      this.element,
      this.matches(element),
      `${component} component element ${Testing.describe(
        element
      )} is invalid for <textarea>.`
    );
  }

  // Static
  static selector = SELECTOR;
}

export default Textarea;
